var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DEFAULT_REQUEST_OPTIONS } from '../_constants';
import { sanitizeHeaders } from './sanitize-headers';
export var mergeRequest = function (api, _a, requestOptions) {
    var _b, _c;
    var _d = _a.baseUrl, baseUrl = _d === void 0 ? '' : _d, baseOptions = __rest(_a, ["baseUrl"]);
    return (__assign(__assign(__assign(__assign({}, DEFAULT_REQUEST_OPTIONS), baseOptions), requestOptions), { headers: __assign(__assign({}, sanitizeHeaders(baseOptions.headers || {})), sanitizeHeaders(requestOptions.headers || {})), signal: (_c = (_b = requestOptions.signal) !== null && _b !== void 0 ? _b : baseOptions.signal) !== null && _c !== void 0 ? _c : api.signal, endpoint: "".concat(baseUrl).concat(requestOptions.endpoint) }));
};
